import PropTypes from "prop-types";
import { memo } from "react";
import { useCurrentFormatCurrency } from "@hooks/usePrices";
import { cn } from "@helpers/general";
import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";
import { ComponentType } from "@constants/ComponentType";

function DiscountedPrice({ componentType, price, isLuxeEnabled }) {
  const formatWithCurrency = useCurrentFormatCurrency();
  return (
    <p
      className={cn("font-bold", {
        "text-secondary": !isLuxeEnabled,
        "typo-h3 mobile:typo-h2":
          componentType === ComponentType.PDP || componentType === ComponentType.PDP_ADS,
        "typo-body": componentType !== ComponentType.PDP && componentType !== ComponentType.PDP_ADS,
      })}
      data-testid="finalPrice"
    >
      {formatWithCurrency(price)}
    </p>
  );
}

DiscountedPrice.propTypes = {
  componentType: PropTypes.string,
  price: PropTypes.number,
  isLuxeEnabled: PropTypes.bool,
};

export default withALErrorBoundary({
  name: "DiscountedPrice",
  priority: "P1",
})(memo(DiscountedPrice));
